/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterOptionDto } from './FilterOptionDto';
import {
    FilterOptionDtoFromJSON,
    FilterOptionDtoFromJSONTyped,
    FilterOptionDtoToJSON,
    FilterOptionDtoToJSONTyped,
} from './FilterOptionDto';

/**
 * 
 * @export
 * @interface ContractFilterOptionsResponseDto
 */
export interface ContractFilterOptionsResponseDto {
    /**
     * 
     * @type {Array<FilterOptionDto>}
     * @memberof ContractFilterOptionsResponseDto
     */
    insured: Array<FilterOptionDto>;
    /**
     * 
     * @type {Array<FilterOptionDto>}
     * @memberof ContractFilterOptionsResponseDto
     */
    reinsured: Array<FilterOptionDto>;
    /**
     * 
     * @type {Array<FilterOptionDto>}
     * @memberof ContractFilterOptionsResponseDto
     */
    brokers: Array<FilterOptionDto>;
    /**
     * 
     * @type {Array<FilterOptionDto>}
     * @memberof ContractFilterOptionsResponseDto
     */
    binders: Array<FilterOptionDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterOptionsResponseDto
     */
    lineOfBusinesses: Array<string>;
    /**
     * 
     * @type {Array<FilterOptionDto>}
     * @memberof ContractFilterOptionsResponseDto
     */
    underwriters: Array<FilterOptionDto>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContractFilterOptionsResponseDto
     */
    underwritingYears: Array<number>;
}

/**
 * Check if a given object implements the ContractFilterOptionsResponseDto interface.
 */
export function instanceOfContractFilterOptionsResponseDto(value: object): value is ContractFilterOptionsResponseDto {
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('reinsured' in value) || value['reinsured'] === undefined) return false;
    if (!('brokers' in value) || value['brokers'] === undefined) return false;
    if (!('binders' in value) || value['binders'] === undefined) return false;
    if (!('lineOfBusinesses' in value) || value['lineOfBusinesses'] === undefined) return false;
    if (!('underwriters' in value) || value['underwriters'] === undefined) return false;
    if (!('underwritingYears' in value) || value['underwritingYears'] === undefined) return false;
    return true;
}

export function ContractFilterOptionsResponseDtoFromJSON(json: any): ContractFilterOptionsResponseDto {
    return ContractFilterOptionsResponseDtoFromJSONTyped(json, false);
}

export function ContractFilterOptionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractFilterOptionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insured': ((json['insured'] as Array<any>).map(FilterOptionDtoFromJSON)),
        'reinsured': ((json['reinsured'] as Array<any>).map(FilterOptionDtoFromJSON)),
        'brokers': ((json['brokers'] as Array<any>).map(FilterOptionDtoFromJSON)),
        'binders': ((json['binders'] as Array<any>).map(FilterOptionDtoFromJSON)),
        'lineOfBusinesses': json['lineOfBusinesses'],
        'underwriters': ((json['underwriters'] as Array<any>).map(FilterOptionDtoFromJSON)),
        'underwritingYears': json['underwritingYears'],
    };
}

export function ContractFilterOptionsResponseDtoToJSON(json: any): ContractFilterOptionsResponseDto {
    return ContractFilterOptionsResponseDtoToJSONTyped(json, false);
}

export function ContractFilterOptionsResponseDtoToJSONTyped(value?: ContractFilterOptionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insured': ((value['insured'] as Array<any>).map(FilterOptionDtoToJSON)),
        'reinsured': ((value['reinsured'] as Array<any>).map(FilterOptionDtoToJSON)),
        'brokers': ((value['brokers'] as Array<any>).map(FilterOptionDtoToJSON)),
        'binders': ((value['binders'] as Array<any>).map(FilterOptionDtoToJSON)),
        'lineOfBusinesses': value['lineOfBusinesses'],
        'underwriters': ((value['underwriters'] as Array<any>).map(FilterOptionDtoToJSON)),
        'underwritingYears': value['underwritingYears'],
    };
}

